/**
 * Store Locator - Retailer Request Form JavaScript
 *
 * Handles:
 * - Collapsible banner toggle
 * - Photo upload to Shopify via worker
 * - Form submission
 * - Admin: Pending requests tab
 * - Admin: Approve/Reject workflow
 */

(function() {
  'use strict';

  // Configuration - Cloudflare Worker proxy URL
  // NOTE: Using 'var' for ES5 compatibility with Shopify CDN minifier
  var PROXY_URL = window.STORE_LOCATOR_PROXY_URL || 'https://figgyz-store-locator.f4f.workers.dev';

  // State
  var uploadedPhotos = [];
  var pendingRequests = [];

  // ==========================================================================
  // INITIALIZATION
  // ==========================================================================

  function init() {
    setupBannerToggle();
    setupPhotoUpload();
    setupFormSubmission();

    // Admin functions (only run if admin panel exists)
    if (document.getElementById('slAdminPanel')) {
      setupAdminTabs();
    }
  }

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ==========================================================================
  // BANNER TOGGLE
  // ==========================================================================

  function setupBannerToggle() {
    var banner = document.getElementById('slRetailerBanner');
    var header = document.getElementById('slRetailerHeader');

    if (!banner || !header) return;

    header.addEventListener('click', function() {
      banner.classList.toggle('expanded');

      // Update button text
      var btn = header.querySelector('.sl-retailer-toggle span:first-child');
      if (btn) {
        btn.textContent = banner.classList.contains('expanded') ? 'Close Form' : 'Get Listed';
      }
    });
  }

  // ==========================================================================
  // PHOTO UPLOAD
  // ==========================================================================

  function setupPhotoUpload() {
    var zone = document.getElementById('slPhotoUploadZone');
    var input = document.getElementById('slPhotoInput');
    var grid = document.getElementById('slPhotoPreviewGrid');

    if (!zone || !input || !grid) return;

    // Click to upload
    zone.addEventListener('click', function() { input.click(); });

    // File input change
    input.addEventListener('change', function(e) {
      handleFiles(e.target.files);
    });

    // Drag and drop
    zone.addEventListener('dragover', function(e) {
      e.preventDefault();
      zone.classList.add('dragover');
    });

    zone.addEventListener('dragleave', function() {
      zone.classList.remove('dragover');
    });

    zone.addEventListener('drop', function(e) {
      e.preventDefault();
      zone.classList.remove('dragover');
      handleFiles(e.dataTransfer.files);
    });
  }

  function handleFiles(files) {
    var maxFiles = 5;
    var maxSize = 5 * 1024 * 1024; // 5MB

    for (var i = 0; i < files.length; i++) {
      var file = files[i];
      if (uploadedPhotos.length >= maxFiles) {
        alert('Maximum ' + maxFiles + ' photos allowed');
        break;
      }

      if (!file.type.startsWith('image/')) {
        alert('Please upload only image files');
        continue;
      }

      if (file.size > maxSize) {
        alert('File "' + file.name + '" is too large. Maximum 5MB per file.');
        continue;
      }

      uploadPhoto(file);
    }
  }

  function uploadPhoto(file) {
    var grid = document.getElementById('slPhotoPreviewGrid');
    if (!grid) return;

    // Create preview element
    var preview = document.createElement('div');
    preview.className = 'sl-photo-preview';
    preview.innerHTML = '<img src="' + URL.createObjectURL(file) + '" alt="Preview">' +
      '<div class="sl-photo-preview-uploading"></div>';
    grid.appendChild(preview);

    // Upload to Shopify via worker
    var formData = new FormData();
    formData.append('file', file);

    // Get Turnstile token for verification
    var tokenEl = document.getElementById('slTurnstileToken');
    var turnstileToken = tokenEl ? tokenEl.value : '';

    fetch(PROXY_URL + '/upload', {
      method: 'POST',
      headers: {
        'X-Turnstile-Token': turnstileToken
      },
      body: formData
    })
    .then(function(response) { return response.json(); })
    .then(function(result) {
      if (result.success && result.url) {
        // Upload successful
        uploadedPhotos.push(result.url);

        // Update preview
        preview.innerHTML = '<img src="' + result.url + '" alt="Uploaded">' +
          '<button type="button" class="sl-photo-preview-remove" onclick="window.removeUploadedPhoto(' + (uploadedPhotos.length - 1) + ', this)">&times;</button>';
      } else {
        throw new Error(result.error || 'Upload failed');
      }
    })
    .catch(function(error) {
      console.error('Photo upload error:', error);
      preview.remove();
      alert('Failed to upload photo. Please try again.');
    });
  }

  // Global function to remove photo
  window.removeUploadedPhoto = function(index, button) {
    uploadedPhotos.splice(index, 1);
    button.closest('.sl-photo-preview').remove();

    // Update remaining remove buttons indices
    var grid = document.getElementById('slPhotoPreviewGrid');
    if (grid) {
      var buttons = grid.querySelectorAll('.sl-photo-preview-remove');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('onclick', 'window.removeUploadedPhoto(' + i + ', this)');
      }
    }
  };

  // ==========================================================================
  // FORM SUBMISSION
  // ==========================================================================

  function setupFormSubmission() {
    var form = document.getElementById('slRetailerForm');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var submitBtn = form.querySelector('.sl-form-submit-btn');
      var messageDiv = document.getElementById('slFormMessage');

      // Validate required fields
      var required = form.querySelectorAll('[required]');
      var valid = true;
      for (var i = 0; i < required.length; i++) {
        var field = required[i];
        if (!field.value.trim()) {
          field.style.borderColor = '#E14826';
          valid = false;
        } else {
          field.style.borderColor = '';
        }
      }

      // Validate at least 1 photo
      if (uploadedPhotos.length === 0) {
        alert('Please upload at least one photo of Figgyz products in your store');
        return;
      }

      if (!valid) {
        alert('Please fill in all required fields');
        return;
      }

      // Validate Turnstile CAPTCHA
      var tokenEl = document.getElementById('slTurnstileToken');
      var turnstileToken = tokenEl ? tokenEl.value : '';
      if (!turnstileToken) {
        alert('Please complete the CAPTCHA verification');
        return;
      }

      // Get form data - with null checks for optional fields
      var phoneEl = form.querySelector('[name="phone"]');
      var websiteEl = form.querySelector('[name="website"]');
      var storeTypeEl = form.querySelector('[name="store_type"]:checked');
      var durationEl = form.querySelector('[name="duration"]');
      var notesEl = form.querySelector('[name="notes"]');

      var formData = {
        store_name: form.querySelector('[name="store_name"]').value.trim(),
        contact_name: form.querySelector('[name="contact_name"]').value.trim(),
        email: form.querySelector('[name="email"]').value.trim(),
        phone: phoneEl ? phoneEl.value.trim() : '',
        website: websiteEl ? websiteEl.value.trim() : '',
        address: form.querySelector('[name="address"]').value.trim(),
        city: form.querySelector('[name="city"]').value.trim(),
        state: form.querySelector('[name="state"]').value.trim(),
        zip: form.querySelector('[name="zip"]').value.trim(),
        country: form.querySelector('[name="country"]').value,
        store_type: storeTypeEl ? storeTypeEl.value : 'retail',
        duration: durationEl ? durationEl.value : '',
        notes: notesEl ? notesEl.value.trim() : '',
        photos: uploadedPhotos,
        turnstileToken: turnstileToken
      };

      // Show loading state
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      fetch(PROXY_URL + '/store-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Turnstile-Token': turnstileToken
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        // Handle rate limiting
        if (response.status === 429) {
          return response.json().then(function(result) {
            var retryAfter = parseInt(response.headers.get('Retry-After')) || result.retryAfter || 3600;
            var error = new Error(result.error || 'Too many requests');
            error.retryAfter = retryAfter;
            throw error;
          });
        }
        return response.json();
      })
      .then(function(result) {
        if (result.success) {
          // Show success message
          messageDiv.className = 'sl-form-message success';
          messageDiv.innerHTML = '<strong>Thank you for your submission!</strong><br>' +
            'We\'ve received your request and will review it shortly. We\'ll be in touch soon!';
          messageDiv.style.display = 'block';

          // Reset form
          form.reset();
          uploadedPhotos = [];
          document.getElementById('slPhotoPreviewGrid').innerHTML = '';

          // Reset Turnstile widget
          resetTurnstile();

          // Scroll to message
          messageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          throw new Error(result.error || 'Submission failed');
        }
      })
      .catch(function(error) {
        console.error('Form submission error:', error);

        // Reset Turnstile on error so user can try again
        resetTurnstile();

        // Check for rate limit error
        var errorMessage = error.message || 'Please try again or contact us directly.';
        if (error.retryAfter) {
          var minutes = Math.ceil(error.retryAfter / 60);
          errorMessage = 'Too many submissions. Please try again in ' + minutes + ' minute' + (minutes !== 1 ? 's' : '') + '.';
        }

        messageDiv.className = 'sl-form-message error';
        messageDiv.innerHTML = '<strong>Submission Failed</strong><br>' + errorMessage;
        messageDiv.style.display = 'block';
      })
      .finally(function() {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      });
    });
  }

  // ==========================================================================
  // ADMIN: TABS
  // ==========================================================================

  function setupAdminTabs() {
    var tabs = document.querySelectorAll('.sl-admin-tab');
    var contents = document.querySelectorAll('.sl-admin-content');

    for (var i = 0; i < tabs.length; i++) {
      (function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.dataset.tab;

          // Update active states
          for (var j = 0; j < tabs.length; j++) { tabs[j].classList.remove('active'); }
          for (var k = 0; k < contents.length; k++) { contents[k].classList.remove('active'); }

          tab.classList.add('active');
          document.getElementById('slAdmin' + capitalize(target)).classList.add('active');

          // Load pending requests when tab is clicked
          if (target === 'requests') {
            loadPendingRequests();
          }
        });
      })(tabs[i]);
    }
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // ==========================================================================
  // ADMIN: PENDING REQUESTS
  // ==========================================================================

  function loadPendingRequests() {
    var container = document.getElementById('slRequestsContainer');
    var badge = document.querySelector('.sl-admin-tab[data-tab="requests"] .sl-admin-tab-badge');

    if (!container) return;

    container.innerHTML = '<div style="text-align: center; color: #aaa; padding: 40px;">Loading requests...</div>';

    fetch(PROXY_URL + '/store-requests?status=pending')
      .then(function(response) { return response.json(); })
      .then(function(result) {
        pendingRequests = result.requests || [];

        // Update badge count
        if (badge) {
          badge.textContent = pendingRequests.length;
          badge.style.display = pendingRequests.length > 0 ? 'block' : 'none';
        }

        if (pendingRequests.length === 0) {
          container.innerHTML = '<div class="sl-requests-empty">' +
            '<div class="sl-requests-empty-icon">📭</div>' +
            '<h3>No Pending Requests</h3>' +
            '<p>New retailer requests will appear here</p>' +
            '</div>';
          return;
        }

        var cards = [];
        for (var i = 0; i < pendingRequests.length; i++) {
          cards.push(createRequestCard(pendingRequests[i]));
        }
        container.innerHTML = cards.join('');
      })
      .catch(function(error) {
        console.error('Error loading requests:', error);
        container.innerHTML = '<div style="text-align: center; color: #E14826; padding: 40px;">' +
          'Failed to load requests. Please try again.</div>';
      });
  }

  function createRequestCard(request) {
    var submittedDate = request.submitted_at
      ? new Date(request.submitted_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      : 'Unknown';

    var photoCount = Array.isArray(request.photos) ? request.photos.length : 0;

    var phoneSection = request.phone ?
      '<div class="sl-request-detail"><span class="sl-request-detail-icon">📞</span>' + escapeHtml(request.phone) + '</div>' : '';

    var photoButton = photoCount > 0 ?
      '<button class="sl-request-btn sl-request-btn-photos" onclick="window.showRequestPhotos(\'' + request.id + '\')">View Photos</button>' : '';

    return '<div class="sl-request-card" data-request-id="' + request.id + '">' +
      '<div class="sl-request-header">' +
        '<h4 class="sl-request-store-name">' + escapeHtml(request.store_name || 'Unknown Store') + '</h4>' +
        '<span class="sl-request-date">Submitted: ' + submittedDate + '</span>' +
      '</div>' +
      '<div class="sl-request-details">' +
        '<div class="sl-request-detail">' +
          '<span class="sl-request-detail-icon">📍</span>' +
          escapeHtml(request.address || '') + ', ' + escapeHtml(request.city || '') + ', ' + escapeHtml(request.state || '') + ' ' + escapeHtml(request.zip || '') + ', ' + escapeHtml(request.country || '') +
        '</div>' +
        '<div class="sl-request-detail">' +
          '<span class="sl-request-detail-icon">📧</span>' +
          escapeHtml(request.email || '') +
        '</div>' +
        phoneSection +
        '<div class="sl-request-photos">' +
          '<span>📷</span>' +
          photoCount + ' photo' + (photoCount !== 1 ? 's' : '') + ' submitted ' +
          photoButton +
        '</div>' +
      '</div>' +
      '<div class="sl-request-actions">' +
        '<button class="sl-request-btn sl-request-btn-approve" onclick="window.approveRequest(\'' + request.id + '\')">✓ Review & Approve</button>' +
        '<button class="sl-request-btn sl-request-btn-reject" onclick="window.rejectRequest(\'' + request.id + '\')">✗ Reject</button>' +
      '</div>' +
    '</div>';
  }

  // ==========================================================================
  // ADMIN: APPROVE REQUEST
  // ==========================================================================

  window.approveRequest = function(requestId) {
    var request = null;
    for (var i = 0; i < pendingRequests.length; i++) {
      if (pendingRequests[i].id === requestId) {
        request = pendingRequests[i];
        break;
      }
    }
    if (!request) return;

    // Pre-fill the Add New Store form with request data
    var form = document.getElementById('slManualStoreForm');
    if (form) {
      // Pre-fill form fields
      var fields = {
        'slManualName': request.store_name,
        'slManualType': request.store_type,
        'slManualAddress': request.address,
        'slManualCity': request.city,
        'slManualState': request.state,
        'slManualZip': request.zip,
        'slManualCountry': request.country,
        'slManualPhone': request.phone,
        'slManualEmail': request.email,
        'slManualWebsite': request.website
      };

      for (var id in fields) {
        if (fields.hasOwnProperty(id)) {
          var input = document.getElementById(id);
          if (input && fields[id]) {
            input.value = fields[id];
          }
        }
      }

      // Switch to stores tab
      var storesTab = document.querySelector('.sl-admin-tab[data-tab="stores"]');
      if (storesTab) {
        storesTab.click();
      }

      // Scroll to form
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Store the request ID for later status update
      window.pendingApprovalRequestId = requestId;

      // Show notification
      alert('Form pre-filled with request data. Please verify coordinates, get the street view photo, set hours, and save the store.');
    } else {
      // Fallback: create JSON for bulk input
      var storeData = {
        name: request.store_name,
        type: request.store_type || 'retail',
        address: request.address,
        city: request.city,
        state: request.state,
        zip: request.zip,
        country: request.country || 'US',
        phone: request.phone,
        email: request.email,
        website: request.website
      };

      var bulkInput = document.getElementById('slBulkInput');
      if (bulkInput) {
        bulkInput.value = JSON.stringify([storeData], null, 2);
      }

      // Switch to stores tab
      var storesTab2 = document.querySelector('.sl-admin-tab[data-tab="stores"]');
      if (storesTab2) {
        storesTab2.click();
      }

      window.pendingApprovalRequestId = requestId;
      alert('Store data ready in bulk input. Process the import, then the request will be marked as approved.');
    }
  };

  // Hook into store save to update request status
  window.markRequestApproved = function() {
    if (!window.pendingApprovalRequestId) return;

    fetch(PROXY_URL + '/update-request-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: window.pendingApprovalRequestId,
        status: 'approved'
      })
    })
    .then(function() {
      window.pendingApprovalRequestId = null;
      console.log('Request marked as approved');
    })
    .catch(function(error) {
      console.error('Failed to update request status:', error);
    });
  };

  // ==========================================================================
  // ADMIN: REJECT REQUEST
  // ==========================================================================

  window.rejectRequest = function(requestId) {
    if (!confirm('Are you sure you want to reject this request?')) return;

    fetch(PROXY_URL + '/update-request-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: requestId,
        status: 'rejected'
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(result) {
      if (result.success) {
        // Remove card from UI
        var card = document.querySelector('.sl-request-card[data-request-id="' + requestId + '"]');
        if (card) {
          card.style.opacity = '0';
          card.style.transform = 'translateX(20px)';
          setTimeout(function() {
            card.remove();
            // Update badge
            var badge = document.querySelector('.sl-admin-tab[data-tab="requests"] .sl-admin-tab-badge');
            if (badge) {
              var count = parseInt(badge.textContent) - 1;
              badge.textContent = count;
              if (count <= 0) badge.style.display = 'none';
            }
          }, 300);
        }
      } else {
        throw new Error(result.error);
      }
    })
    .catch(function(error) {
      console.error('Error rejecting request:', error);
      alert('Failed to reject request. Please try again.');
    });
  };

  // ==========================================================================
  // ADMIN: PHOTO GALLERY MODAL
  // ==========================================================================

  window.showRequestPhotos = function(requestId) {
    var request = null;
    for (var i = 0; i < pendingRequests.length; i++) {
      if (pendingRequests[i].id === requestId) {
        request = pendingRequests[i];
        break;
      }
    }
    if (!request || !request.photos || request.photos.length === 0) return;

    // Create modal if it doesn't exist
    var modal = document.getElementById('slPhotoModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'slPhotoModal';
      modal.className = 'sl-photo-modal';
      modal.innerHTML = '<div class="sl-photo-modal-content">' +
        '<div class="sl-photo-modal-header">' +
          '<h3 class="sl-photo-modal-title">Submitted Photos</h3>' +
          '<button class="sl-photo-modal-close" onclick="window.closePhotoModal()">&times;</button>' +
        '</div>' +
        '<div class="sl-photo-modal-grid" id="slPhotoModalGrid"></div>' +
      '</div>';
      document.body.appendChild(modal);

      // Close on background click
      modal.addEventListener('click', function(e) {
        if (e.target === modal) window.closePhotoModal();
      });
    }

    // Populate grid
    var grid = document.getElementById('slPhotoModalGrid');
    var photoHtml = [];
    for (var j = 0; j < request.photos.length; j++) {
      var url = request.photos[j];
      photoHtml.push('<div class="sl-photo-modal-item">' +
        '<img src="' + escapeHtml(url) + '" alt="Store photo" onclick="window.open(\'' + escapeHtml(url) + '\', \'_blank\')">' +
      '</div>');
    }
    grid.innerHTML = photoHtml.join('');

    // Update title
    modal.querySelector('.sl-photo-modal-title').textContent = 'Photos: ' + escapeHtml(request.store_name);

    // Show modal
    modal.classList.add('visible');
  };

  window.closePhotoModal = function() {
    var modal = document.getElementById('slPhotoModal');
    if (modal) {
      modal.classList.remove('visible');
    }
  };

  // ==========================================================================
  // UTILITIES
  // ==========================================================================

  function escapeHtml(text) {
    if (!text) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Reset the Turnstile CAPTCHA widget
   */
  function resetTurnstile() {
    var widget = document.getElementById('slTurnstileWidget');
    var tokenInput = document.getElementById('slTurnstileToken');

    if (tokenInput) {
      tokenInput.value = '';
    }

    // Use Turnstile API to reset if available
    if (window.turnstile && widget) {
      try {
        // Get the widget ID from the container
        var widgetId = widget.dataset.widgetId;
        if (widgetId) {
          window.turnstile.reset(widgetId);
        } else {
          // If no widget ID, try to reset all widgets
          window.turnstile.reset();
        }
      } catch (e) {
        console.warn('Turnstile reset failed:', e);
        // Fallback: re-render the widget
        if (window.TURNSTILE_SITE_KEY) {
          widget.innerHTML = '';
          window.turnstile.render(widget, {
            sitekey: window.TURNSTILE_SITE_KEY,
            callback: window.slOnTurnstileSuccess,
            'expired-callback': window.slOnTurnstileExpired,
            'error-callback': window.slOnTurnstileError,
            theme: 'light'
          });
        }
      }
    }
  }

  // Export for external access
  window.slLoadPendingRequests = loadPendingRequests;
})();
